var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFornoAria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 38,
    viewBox: "0 0 20 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3067_110230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-0.83205 0.5547 0 1 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3067_110230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7659 11.8509L13.0124 10.3532C13.2246 10.2117 13.4025 10.0067 13.546 9.73797C13.6895 9.46945 13.7613 9.20844 13.7613 8.95494C13.7613 8.70144 13.6896 8.53674 13.5462 8.46083C13.4028 8.38492 13.2251 8.41765 13.0131 8.559L7.0277 12.5492C6.81566 12.6906 6.63684 12.8956 6.49124 13.1641C6.34563 13.4327 6.27282 13.6937 6.27282 13.9472C6.27282 14.2007 6.34459 14.3661 6.48811 14.4432C6.63164 14.5205 6.8095 14.4885 7.02167 14.347L9.2682 12.8493V14.6536C9.2682 14.9091 9.33997 15.0755 9.4835 15.1528C9.62703 15.2299 9.80488 15.1978 10.017 15.0563C10.2292 14.9149 10.4071 14.7099 10.5506 14.4414C10.6941 14.1727 10.7659 13.9106 10.7659 13.6551V11.8509ZM16.0078 22.1878V16.7448C16.0078 16.4899 15.9365 16.3226 15.7938 16.2427C15.6511 16.1628 15.4743 16.1932 15.2633 16.3338C15.0524 16.4744 14.875 16.6792 14.7312 16.948C14.5873 17.217 14.5153 17.4793 14.5153 17.735V17.7575L12.2636 19.2587V16.5587L12.2823 16.5462C12.495 16.4044 12.6734 16.1992 12.8173 15.9307C12.9613 15.6623 13.0332 15.4006 13.0332 15.1456C13.0332 14.8906 12.9615 14.7246 12.8179 14.6478C12.6745 14.5709 12.4968 14.6032 12.2846 14.7446L7.75574 17.7639C7.54371 17.9052 7.36489 18.1102 7.21928 18.3788C7.07367 18.6473 7.00087 18.9084 7.00087 19.1619C7.00087 19.4154 7.07284 19.5806 7.21678 19.6574C7.36073 19.7345 7.53906 19.7021 7.75179 19.5603L7.77051 19.5478V22.254L5.52398 23.7517V23.7292C5.52398 23.4736 5.45221 23.3071 5.30868 23.2298C5.16516 23.1524 4.9873 23.1845 4.77513 23.326C4.56296 23.4674 4.38511 23.6722 4.24158 23.9404C4.09805 24.2084 4.02629 24.4699 4.02629 24.7249V30.1679C4.02629 30.4228 4.09763 30.5901 4.24033 30.67C4.38303 30.7499 4.55984 30.7195 4.77076 30.5789C4.98169 30.4383 5.15898 30.2338 5.30265 29.9655C5.44618 29.6973 5.51795 29.4357 5.51795 29.1807V29.1557L14.5101 23.161V23.186C14.5101 23.441 14.5815 23.6071 14.7242 23.6845C14.8669 23.7619 15.0437 23.7303 15.2546 23.5896C15.4655 23.449 15.6438 23.2439 15.7894 22.9744C15.935 22.705 16.0078 22.4428 16.0078 22.1878ZM14.5101 21.361L5.52398 27.3517V25.5517L9.2682 23.0556V18.5556L10.7659 17.5571V22.0571L14.5101 19.561V21.361Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFornoAria);
export default __webpack_public_path__ + "static/media/forno-aria.f855fbd2f678c00d3744341a2296136a.svg";
export { ForwardRef as ReactComponent };